export enum TuitionBillingCycle {
  ONE_TIME = 'one-time',
  EVERY_X_DAYS = 'every-x-days',
}

const BILLING_CYCLE_LABELS: Record<string, string> = {
  'one-time': 'One Time',
  weekly: 'Weekly',
  'bi-weekly': 'Bi-Weekly',
  monthly: 'Monthly',
  hourly: 'Hourly',
};

export function formatBillingCycle(
  cycle: string | undefined,
  billingFrequencyDays?: number,
): string {
  if (!cycle) return '';
  if (cycle === TuitionBillingCycle.EVERY_X_DAYS) {
    return billingFrequencyDays
      ? `Every ${billingFrequencyDays} Days`
      : 'Every X Days';
  }
  return BILLING_CYCLE_LABELS[cycle] ?? cycle;
}
